export const getIsSuccessfulResponse = (status: number) => {
    if (status >= 200 && status <= 299) {
        return true;
    }
};
